import { useMemo } from 'react';
import routes from '@config/routes';
import { useApp } from '@context/AppContext';
import { useRouter } from 'next/router';

export function useContextVendorId(vendorIdOverride = '') {
  const { user } = useApp();
  const router = useRouter();

  const pathVendorId = useMemo(() => {
    let id = '';
    if (
      typeof router.query.state === 'string' &&
      (router.pathname.includes('settings/ordering') ||
        router.pathname.includes(
          routes.dashboard.settings.orderingSettingsWizardPath
        ))
    ) {
      // This is where the vendor ID is stored when Stripe onboarding redirects back to Goodfynd for initial vendor setup
      id = router.query.state.split('|')[0];
    }

    let vendorId = id || router.query.vendorId || router.query.vendor_id;
    if (vendorId === '~' && user?.permissions?.[0]) {
      vendorId =
        user.permissions.find(
          (permission) =>
            permission.entityType === 'Vendor' &&
            permission.entityId === user.defaultVendorId
        )?.entityNameId ??
        user.defaultVendorId ??
        user.permissions[0]?.entityNameId;
      const newPath = router.asPath.replace('/~', `/${vendorId}`);
      router.replace(newPath);
      return vendorId;
    }

    return vendorId;
  }, [router, user?.defaultVendorId, user?.permissions]);

  const vendorId: string = useMemo(
    () => vendorIdOverride || (pathVendorId as string) || '',
    [pathVendorId, vendorIdOverride]
  );

  return vendorId;
}
